/** Shared pagination cutoff for staff table views. */
export const STAFF_GRID_PAGINATION_THRESHOLD = 25;
